import React from "react";
import Input from "../pages/input.js";

function Survey() {
  return (
    <div>
      <h1>Survey Page</h1>
      <Input />
    </div>
  );
};

export default Survey;
